   document.addEventListener('DOMContentLoaded', () => {
        const accordionButton = document.querySelectorAll('.wg__accordion-button');
        accordionButton.forEach((button) => {
            button.addEventListener('click', () => {
                const isExpanded = button.getAttribute('aria-expanded') === 'true';
                button.setAttribute('aria-expanded', String(!isExpanded));
            })
        })
    })